import PropTypes from 'prop-types'
import { Avatar, AvatarFallback, AvatarImage } from '@components/ui/avatar'

export const AdasAvatar = ({
  src,
  alt = '',
  children,
  className,
  // eslint-disable-next-line no-unused-vars
  sx,
  ...props
}) => {
  const fallback = children || alt?.charAt(0)?.toUpperCase() || '?'
  return (
    <Avatar className={className} {...props}>
      {src && <AvatarImage src={src} alt={alt} />}
      <AvatarFallback>{fallback}</AvatarFallback>
    </Avatar>
  )
}

AdasAvatar.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string
}
